import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('base-modal-layout-header', {
  innerContent: {},
  title: {},
  subtitle: {},
});
